import React, { useState } from "react"
import { useI18next } from "gatsby-plugin-react-i18next"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LanguagePickerModal } from "./LanguagePickerModal"
import { getFormattedLanguage } from "../../util/languageUtil"
import { TextBase } from "../typography/headings"

type Props = {
  className?: string
}

export const LanguagePickerSelector = ({ className }: Props) => {
  const { language } = useI18next()
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }

  const hideModal = () => {
    setShowModal(false)
  }

  return (
    <>
      <TextBase
        fontFamily="Inter400"
        className={`text-textPrimary cursor-pointer hover:text-ctaMain ${
          className || ""
        }`}
        onClick={openModal}
      >
        <FontAwesomeIcon icon={solid("earth")} />{" "}
        {getFormattedLanguage(language)}
      </TextBase>
      <LanguagePickerModal hideModal={hideModal} isVisible={showModal} />
    </>
  )
}
